import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyA7qLGd9vtk8s0kK8Lr7zqiVxJCbAdu71g",
  authDomain: "shopsquares.firebaseapp.com",
  projectId: "shopsquares",
  storageBucket: "shopsquares.appspot.com",
  messagingSenderId: "577377261380",
  appId: "1:577377261380:web:6895532b22cd891b666911"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export {app};